export default __webpack_public_path__ + "static/media/imagefourteen.19517575.gif";